var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import CrudSidesheetMixin from '@/mixins/crud-sidesheet-mixin';
import BaseCrudSidesheet from '@/components/base/BaseCrudSidesheet.vue';
import ItemsMixin from '@/mixins/items-mixin';
import { CarrierGroup } from '@/typings';
import { lazyInject } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
import { CarrierGroupService } from '@/services/carrier-management/carrier-group-service';
import SnackbarMixin from '@/mixins/snackbar-mixin';
var ManageGroupCrudSidesheet = /** @class */ (function (_super) {
    __extends(ManageGroupCrudSidesheet, _super);
    function ManageGroupCrudSidesheet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.carriers = [];
        return _this;
    }
    ManageGroupCrudSidesheet.prototype.onItemChanged = function (val, oldVal) {
        if ((val.id !== oldVal.id && val) || val.id === '0') {
            this.initializeSidesheet();
        }
    };
    ManageGroupCrudSidesheet.prototype.initializeSidesheet = function () {
        return __awaiter(this, void 0, void 0, function () {
            var carrierGroup, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        carrierGroup = this.selectedItem;
                        // set the default carrier group name if one is provided
                        if (this.defaultName && this.defaultName.length > 0) {
                            carrierGroup.name = this.defaultName;
                            this.selectedItem = carrierGroup;
                        }
                        if (!this.includeCarriers) return [3 /*break*/, 2];
                        // carrier reference data
                        _a = this;
                        return [4 /*yield*/, this.referenceDataService.get('/carrier/getcarriers')];
                    case 1:
                        // carrier reference data
                        _a.carriers = _b.sent();
                        // A Carrier can be associated with only one Carrier Group.
                        // exclude carriers that have carrier groups
                        this.carriers =
                            carrierGroup.id === ''
                                ? // new carrier group
                                    this.carriers.filter(function (carrier) { return carrier.groupId === null || carrier.groupId === ''; })
                                : // existing carrier group
                                    this.carriers.filter(function (carrier) {
                                        return carrier.groupId === null ||
                                            carrier.groupId === '' ||
                                            carrier.groupId === carrierGroup.id;
                                    });
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ManageGroupCrudSidesheet.prototype.saving = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        data = __assign({}, this.selectedItem);
                        // clear out any carriers if creating a new carrier group from carrier management
                        if (this.includeCarriers === false) {
                            data.carriers = [];
                        }
                        return [4 /*yield*/, this.carrierGroupService.save(data)];
                    case 1:
                        response = _a.sent();
                        if (response.success === false) {
                            this.showSnackbar({ text: response.message, color: 'error' });
                            return [2 /*return*/];
                        }
                        // update data with new id
                        data.id = response.data.carrierGroupId;
                        // update module collection
                        this.updateItemsCollection(data, ['id']);
                        // send back to parent
                        this.$emit('saved', data);
                        this.showSnackbar({
                            text: 'Carrier Group changes saved',
                            color: 'success',
                        });
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        this.showSnackbar({
                            text: 'Unable to save Carrier Group',
                            color: 'error',
                        });
                        // send back to parent
                        this.$emit('saved', null);
                        return [3 /*break*/, 4];
                    case 3:
                        this.close();
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    var _a, _b, _c;
    __decorate([
        lazyInject(TYPES.CarrierGroupService),
        __metadata("design:type", typeof (_a = typeof CarrierGroupService !== "undefined" && CarrierGroupService) === "function" ? _a : Object)
    ], ManageGroupCrudSidesheet.prototype, "carrierGroupService", void 0);
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], ManageGroupCrudSidesheet.prototype, "defaultName", void 0);
    __decorate([
        Prop({ type: Boolean, default: true }),
        __metadata("design:type", Boolean)
    ], ManageGroupCrudSidesheet.prototype, "includeCarriers", void 0);
    __decorate([
        Watch('selectedItem', { immediate: false, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof CarrierGroup !== "undefined" && CarrierGroup) === "function" ? _b : Object, typeof (_c = typeof CarrierGroup !== "undefined" && CarrierGroup) === "function" ? _c : Object]),
        __metadata("design:returntype", void 0)
    ], ManageGroupCrudSidesheet.prototype, "onItemChanged", null);
    ManageGroupCrudSidesheet = __decorate([
        Component({
            components: {
                'base-crud-sidesheet': BaseCrudSidesheet,
            },
        })
    ], ManageGroupCrudSidesheet);
    return ManageGroupCrudSidesheet;
}(Mixins(CrudSidesheetMixin, ItemsMixin, SnackbarMixin)));
export default ManageGroupCrudSidesheet;
